/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Button } from 'antd';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { requestAppConfig } from '../../../state/ui/application/appConfigUiActions';
import { selectAppConfig } from '../../../state/domain/appConfig/appConfigReducer';

const RegistrationWelcome = ({ wizardNext, trialDuration, loadTrialDuration }) => {
  const intl = useIntl();
  useEffect(() => {
    loadTrialDuration();
  }, [loadTrialDuration]);
  const trialLengthDays = trialDuration ? trialDuration.applicationConfigValue / (60 * 60 * 24) : null;
  return (
    <Row style={{ width: '100%' }}>
      <Row type="flex" justify="start" style={{ marginTop: '0.5em', marginRight: '2em' }}>
        <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'registrationExplanation' }, { trialDuration: trialLengthDays || 0 }) }} />
      </Row>
      <Row type="flex" justify="end" style={{ marginTop: '0.5em', marginRight: '2em' }}>
        <Button loading={false} type="primary" style={{ marginRight: '0.5em' }} onClick={() => wizardNext(true)}>
          <FormattedMessage id="next" />
        </Button>
      </Row>
    </Row>
  );
};

RegistrationWelcome.propTypes = {
  loadTrialDuration: PropTypes.func.isRequired,
  wizardNext: PropTypes.func.isRequired,
  trialDuration: PropTypes.shape({
    applicationConfigValue: PropTypes.string,
  }),
};

RegistrationWelcome.defaultProps = {
  trialDuration: null,
};

const mapStateToProps = (state) => ({
  trialDuration: selectAppConfig(state, 'NEW_GROUP_TRIAL_LENGTH'),
});

const mapDispatchToProps = dispatch => ({
  loadTrialDuration: () => dispatch(requestAppConfig('NEW_GROUP_TRIAL_LENGTH')),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationWelcome);
